import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useAdultModeQuery } from "@/hooks";
import MetaTags, { adultOrVod } from "./index";
import { useMemo } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

function tags(type) {
  var ext = function () {
    if (type === "complete") {
      return "リセット完了";
    } else if (type === "reset") {
      return "再設定";
    } else {
      return "リセット";
    }
  }();

  return {
    vod: {
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9".concat(ext, " | SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)"),
      keywords: "SPOOX,スプークス,動画配信,見放題,レンタル",
      description: "\u30D1\u30B9\u30EF\u30FC\u30C9".concat(ext, "\u3002SPOOX(\u30B9\u30D7\u30FC\u30AF\u30B9)\u3067\u306F\u3001\u30B9\u30DD\u30FC\u30C4\u3084\u6620\u753B\u3084\u30A2\u30CB\u30E1\u306A\u3069\u3001\u69D8\u3005\u306A\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
      og: {
        type: "article"
      }
    },
    adult: {
      title: "\u30D1\u30B9\u30EF\u30FC\u30C9".concat(ext, " | SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)"),
      keywords: "SPOOX EX,スプークスイーエックス,動画配信,見放題,レンタル",
      description: "\u30D1\u30B9\u30EF\u30FC\u30C9".concat(ext, "\u3002SPOOX EX(\u30B9\u30D7\u30FC\u30AF\u30B9\u30A4\u30FC\u30A8\u30C3\u30AF\u30B9)\u3067\u306F\u3001\u69D8\u3005\u306A\u30A2\u30C0\u30EB\u30C8\u52D5\u753B\u3092\u914D\u4FE1\u4E2D\u3067\u3059\u3002"),
      og: {
        type: "article"
      }
    }
  };
}

export default function PasswordRemindMetaTags(_ref) {
  var type = _ref.type;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var props = tags(type)[adultOrVod(adultMode)];
  var noindex = useMemo(function () {
    if (type) {
      return "noindex";
    } else {
      return null;
    }
  }, [type]);
  return /*#__PURE__*/_jsx(MetaTags, _objectSpread(_objectSpread({}, props), {}, {
    robots: noindex
  }));
}